import { ListingsAPI } from "../../../api/listingsAPI";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  USER_LISTINGS_REQUEST,
  USER_LISTINGS_SUCCESS,
  USER_LISTINGS_ERROR,
} from "../../actions";

function* workerGetUserListings(action: {
  type: string;
  payload: { param: string };
}): Generator<any> {
  try {
    const params = action.payload;
    const data: any = yield call(ListingsAPI.getListings, params);
    yield put({ type: USER_LISTINGS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: USER_LISTINGS_ERROR, payload: error });
  }
}

export function* watcherGetUserListings() {
  yield takeLatest(USER_LISTINGS_REQUEST, workerGetUserListings);
}
